import React, { useContext } from 'react';
import { PurchaseFlowStateContext } from '../../context/PurchaseFlowStateContext';
import { ClientContext } from '../../context/ClientContext';
import { formatCurrency } from '../../utils/numberFormatter';

const showGeneralAvailable = process.env.REACT_APP_PROFILE_SHOW_GENERAL_AVAILABLE !== 'false';

const SaleMonitorCard = () => {
  const { saleState } = useContext(PurchaseFlowStateContext);
  const { clientData } = useContext(ClientContext);
  if (!saleState?.isActive) return null;

  const { selectedProduct, selectedProductPlan, requestedAmount, selectedOfferSummary } = saleState;
  const hasAnyData = selectedProduct || selectedProductPlan || requestedAmount != null || selectedOfferSummary;
  const availableCredit = clientData?.available_credit;

  return (
    <div className="rg-sale-monitor card border-0 shadow-sm mb-0">
      <div className="card-body p-3">
        {showGeneralAvailable && availableCredit != null && (
          <div className="rg-sale-monitor__disponible mb-3">
            <span className="rg-sale-monitor__disponible-label">Disponible</span>
            <span className="rg-sale-monitor__disponible-value">{formatCurrency(availableCredit)}</span>
          </div>
        )}
        <h6 className="card-title small text-muted text-uppercase mb-3" style={{ fontSize: 'var(--rg-font-size-xs)', letterSpacing: 'var(--rg-letter-spacing-wide)' }}>
          Información de la venta
        </h6>
        {!hasAnyData ? (
          <p className="small text-muted mb-0">Avanzá en los pasos para ver el resumen.</p>
        ) : (
          <ul className="list-unstyled small mb-0">
            {selectedProduct && (
              <li className="mb-2">
                <span className="text-muted d-block">Producto</span>
                <span className="fw-semibold">{selectedProduct.name}</span>
                {selectedProduct.maxCapitalEffective > 0 && (
                  <span className="d-block text-muted" style={{ fontSize: 'var(--rg-font-size-xs)' }}>
                    Máx. {formatCurrency(selectedProduct.maxCapitalEffective)}
                  </span>
                )}
              </li>
            )}
            {selectedProductPlan && (
              <li className="mb-2">
                <span className="text-muted d-block">Plan</span>
                <span className="fw-semibold">{selectedProductPlan.label}</span>
              </li>
            )}
            {requestedAmount != null && requestedAmount > 0 && (
              <li className="mb-2">
                <span className="text-muted d-block">Monto solicitado</span>
                <span className="fw-semibold">{formatCurrency(requestedAmount)}</span>
              </li>
            )}
            {selectedOfferSummary && (
              <>
                {selectedOfferSummary.installments != null && (
                  <li className="mb-2">
                    <span className="text-muted d-block">Cuotas</span>
                    <span className="fw-semibold">{selectedOfferSummary.installments}</span>
                  </li>
                )}
                {selectedOfferSummary.installmentAmount != null && selectedOfferSummary.installmentAmount > 0 && (
                  <li className="mb-0">
                    <span className="text-muted d-block">Monto de cuota</span>
                    <span className="fw-semibold">{formatCurrency(selectedOfferSummary.installmentAmount)}</span>
                  </li>
                )}
              </>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SaleMonitorCard;
